/**
 * Created by hp on 2017/5/25.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Mask} from 'react-weui'


class ClassroomRedpackGrabDialog extends Component {
    constructor() {
        super();
        this.onShowUserDialog = this.onShowUserDialog.bind(this);
        this.onHideGrabDialog = this.onHideGrabDialog.bind(this);
        this.onPreventProp = this.onPreventProp.bind(this);
    }

    onPreventProp(e) {
        e.stopPropagation();
    }

    onShowUserDialog() {
        this.props.dispatch({
            type: 'HIDE_REDPACK_GRAB_DIALOG'
        });
        let {lecture, message} = this.props;
        let url = `/api/classroom/${lecture.id}/redpack/${message.meta.redpack_id}/record`;
        axios.get(url).then((res) => {
            this.props.dispatch({
                type: 'SET_REDPACK_USER_OBJECT',
                preload: res.data.data
            });
            this.props.dispatch({
                type: 'SHOW_REDPACK_USER_DIALOG'
            });
        });
    }

    onHideGrabDialog() {
        this.props.dispatch({
            type: 'HIDE_REDPACK_GRAB_DIALOG'
        })
    }

    render() {
        let {showRedpackGrabDialog, redpackGrab} = this.props;
        if(!showRedpackGrabDialog)
            return null
        return (
            <div className="redpack-dialog">
                <Mask onClick={this.onHideGrabDialog} />
                <div className="redpack-inner">
                    <div className="portrait2">
                        <img src={redpackGrab.sender_headimgurl} alt=""/>
                    </div>
                    <p className="nickname">来自{redpackGrab.sender_nickname}</p>
                    {redpackGrab.code === 0 ?
                        <div>
                            <p className="description text-ellipsis">{redpackGrab.description}</p>
                            <p className="fee">
                                <span className="number">{redpackGrab.fee}</span>
                                <span className="unit">元</span>
                            </p>
                            <p className="tips">
                                可在
                                <span className="bold">个人中心</span>
                                查看收益
                            </p>
                        </div>
                        :
                        <p className="redpack-none">{redpackGrab.msg}</p>
                    }
                    <p className="show_user">
                        <a onClick={this.onShowUserDialog}>点击查看大家的手气</a>
                    </p>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    redpackGrab: state.redpack.redpackGrab,
    showRedpackGrabDialog: state.redpack.showRedpackGrabDialog,
    lecture: state.classroom.lecture,
    message: state.redpack.redpackMessage,
}))(ClassroomRedpackGrabDialog)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomRedpackGrabDialog.js